/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useLoanStore } from '@roc/feature-loans';
import { useExtensionsStore } from './useExtensionsStore';
import { useDocumentStore } from '@roc/feature-documents';
import { LoanProcess } from '@roc/feature-utils';
import { GeneralTaskType, TaskV2Type } from '@roc/feature-general-tasks';
import { EXTENSION_PROGRESS_STEPS } from '../utils/extensionsConstants';

export const useExtensions = () => {
  const params = useParams<{ loanId: string }>();
  const loanId = params.loanId;
  const { loanStore } = useLoanStore();
  const loanProcess = LoanProcess.EXTENSIONS;
  const { documentStore } = useDocumentStore();
  const { extensionsStore } = useExtensionsStore();
  const [specialistsDropdown, setSpecialistsDropdown] = useState();
  const [isRequestExtensionDialogOpen, setIsRequestExtensionDialogOpen] = useState(false);
  const [isMarkInsuranceReviewCompleteDialogOpen, setIsMarkInsuranceReviewCompleteDialogOpen] = useState(false);
  const [isRequestExtensionAgreementDialogOpen, setIsRequestExtensionAgreementDialogOpen] = useState(false);
  const [isMarkAsCompleteDialogOpen, setIsMarkAsCompleteDialogOpen] = useState(false);
  const [isMarkAsRetractedDialogOpen, setIsMarkAsRetractedDialogOpen] = useState(false);


  useEffect(() => {
    extensionsStore.initExtensionInternal(loanId);
    async function fetchSpecialistsDropdown() {
      await loanStore.fetchSpecialistsDropdown();
      setSpecialistsDropdown(loanStore.specialistsDropdown);
    }
    fetchSpecialistsDropdown();
  }, [loanId]);

  const handleSelectExtension = (extensionId: number) => {
    const selectedExtension = extensionsStore.extensions.find(extension => extension.loanExtensionId === extensionId);
    extensionsStore.setSelectedExtension(selectedExtension);
    extensionsStore.setSelectedExtensionId(extensionId);
  }

  const handleRequestExtension = () => {
    setIsRequestExtensionDialogOpen(true);
  };

  const handleCloseRequestExtensionDialog = () => {
    setIsRequestExtensionDialogOpen(false);
  };

  const extensionOptions = extensionsStore?.extensions?.map(extension => {
    return {
      label: `Extension ${extension?.extensionNumber}`,
      value: extension?.loanExtensionId,
    }
  }) ?? [];

  const progressSteps = EXTENSION_PROGRESS_STEPS;

  useEffect(() => {
    if (extensionsStore.selectedExtension) {
      documentStore.loanTodosStore.fetchTodos(+loanId, loanProcess, TaskV2Type.EXTENSION_ID, extensionsStore?.selectedExtensionId);
    }
  }, [extensionsStore.selectedExtension]);

  return {
    extensionsStore,
    selectedExtensionId: extensionsStore.selectedExtensionId,
    handleSelectExtension,
    extensionOptions,
    progressSteps,
    activeStep: extensionsStore.selectedExtension?.status,
    specialistsDropdown,
    loanId,
    isRequestExtensionDialogOpen,
    handleRequestExtension,
    handleCloseRequestExtensionDialog,
    hasLoanExtensions: extensionsStore.extensions.length > 0,
    loanProcess,
    documentStore,
    isMarkInsuranceReviewCompleteDialogOpen,
    setIsMarkInsuranceReviewCompleteDialogOpen,
    isRequestExtensionAgreementDialogOpen,
    setIsRequestExtensionAgreementDialogOpen,
    isMarkAsCompleteDialogOpen,
    setIsMarkAsCompleteDialogOpen,
    isMarkAsRetractedDialogOpen,
    setIsMarkAsRetractedDialogOpen,
  };
};
